export const initialValuesContactWizard = {
    primaryContact: {
        contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        lst_Account: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: ""
        },
        contactNo: "",
        organizationId: 0,
        firstName: "",
        lastName: "",
        email: "",
        isDeleted: false,
        imageUrl: "",
        note: "",
        updatedBy: "",
        createdDT: "2024-12-06T10:13:00.346Z",
        updatedDT: "2024-12-06T10:13:00.346Z",
        companyName: "",
        homePhone: "",
        workPhone: "",
        cellPhone: "",
        fax: "",
        homeEmail: "",
        workEmail: "",
        perferredTime: "",
        sourceDescription: "",
        isSubNewsLetter: true,
        isPrimaryContact: true,
        isActive: true,
        addressLine1: "",
        addressLine2: "",
        addressAs: "",
        city: "",
        state: "",
        zipCode: "",
        country: {
            id: 0,
            title: ""
        },
        contactType: {
            id: 17,
            name: "Primary Contact"
        },
        contactStatus: {
            id: 0,
            name: ""
        },
        salutation: {
            id: 0,
            name: ""
        },
        maritalStatus: {
            id: 0,
            name: ""
        },
        genderType: {
            id: 0,
            name: ""
        },
        inquiryMethod: {
            id: 0,
            name: ""
        },
        leadSource: {
            id: 0,
            name: ""
        },
        preferredMethod: {
            id: 0,
            name: ""
        },
        mailingAddress: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            addressLine1: "",
            addressLine2: "",
            zipCode: "",
            stateId: 0,
            stateName: "",
            cityId: 0,
            cityName: "",
            chooseCityId: 0,
            chooseCityName: "",
            addressTypeId: 0,
            addressTypeName: ""
        },
        propertyAddress: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            addressLine1: "",
            addressLine2: "",
            zipCode: "",
            stateId: 0,
            stateName: "",
            cityId: 0,
            cityName: "",
            chooseCityId: 0,
            chooseCityName: "",
            addressTypeId: 0,
            addressTypeName: ""
        }
    },
    secondaryContact: {
        contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        lst_Account: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: ""
        },
        contactNo: "",
        organizationId: 0,
        firstName: "",
        lastName: "",
        email: "",
        isDeleted: false,
        imageUrl: "",
        note: "",
        updatedBy: "",
        createdDT: "2024-12-06T10:13:00.347Z",
        updatedDT: "2024-12-06T10:13:00.347Z",
        companyName: "",
        homePhone: "",
        workPhone: "",
        cellPhone: "",
        fax: "",
        homeEmail: "",
        workEmail: "",
        perferredTime: "",
        sourceDescription: "",
        isSubNewsLetter: true,
        isPrimaryContact: true,
        isActive: true,
        addressLine1: "",
        addressLine2: "",
        addressAs: "",
        city: "",
        state: "",
        zipCode: "",
        country: {
            id: 0,
            title: ""
        },
        contactType: {
            id: 0,
            name: ""
        },
        contactStatus: {
            id: 0,
            name: ""
        },
        salutation: {
            id: 0,
            name: ""
        },
        maritalStatus: {
            id: 0,
            name: ""
        },
        genderType: {
            id: 0,
            name: ""
        },
        inquiryMethod: {
            id: 0,
            name: ""
        },
        leadSource: {
            id: 0,
            name: ""
        },
        preferredMethod: {
            id: 0,
            name: ""
        },
        mailingAddress: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            addressLine1: "",
            addressLine2: "",
            zipCode: "",
            stateId: 0,
            stateName: "",
            cityId: 0,
            cityName: "",
            chooseCityId: 0,
            chooseCityName: "",
            addressTypeId: 0,
            addressTypeName: ""
        },
        propertyAddress: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            addressLine1: "",
            addressLine2: "",
            zipCode: "",
            stateId: 0,
            stateName: "",
            cityId: 0,
            cityName: "",
            chooseCityId: 0,
            chooseCityName: "",
            addressTypeId: 0,
            addressTypeName: ""
        }
    },
    internalComments: "",
    externalComments: ""
}

export const initialValuesContactOppoertuityDetails = {
    projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    opportunityDetailsDescription: {
        projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        description: "",
        analysis: "",
        status: "",
        statusDetails: "",
        jobType: {
            id: 0,
            value: ""
        },
        saleAmount: 0,
        leadSource: "",
        sourceDescription: "",
        adCode: "",
        lst_CreatedBy: {
            id: 0,
            value: ""
        },
        lst_ModifiedBy: {
            id: 0,
            value: ""
        },
        createdDT: "2024-12-19T08:51:11.955Z",
        modifiedDT: "2024-12-19T08:51:11.955Z"
    },
    opportunityDetailsSitution: {
        generalBackground: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2024-12-19T08:51:11.955Z",
                modifiedDT: "2024-12-19T08:51:11.955Z"
            }
        ],
        clientpastHomeRenvExp: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2024-12-19T08:51:11.955Z",
                modifiedDT: "2024-12-19T08:51:11.955Z"
            }
        ],
        clientReasonForProject: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2024-12-19T08:51:11.955Z",
                modifiedDT: "2024-12-19T08:51:11.955Z"
            }
        ],
        projectBackground: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2024-12-19T08:51:11.955Z",
                modifiedDT: "2024-12-19T08:51:11.955Z"
            }
        ]
    },
    opportunityDetailsScopeDTO: {
        opportunityScop: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2024-12-19T08:51:11.955Z",
                modifiedDT: "2024-12-19T08:51:11.955Z"
            }
        ],
        additionScope: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2024-12-19T08:51:11.955Z",
                modifiedDT: "2024-12-19T08:51:11.955Z"
            }
        ],
        detailedScope: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2024-12-19T08:51:11.955Z",
                modifiedDT: "2024-12-19T08:51:11.955Z"
            }
        ]
    }
}
export const initialValuesAppointment = {

    appointmentId: 0,
    recNumber: '',
    leadInquiryId: '',
    lst_SelAppointmentType: {
        id: 1,
        value: 'Fresh Appointment'
    },
    startDate: "",
    startTime: "",
    lst_duration: {
        id: 0,
        value: ''
    },
    lst_FreshAptLocation: {
        id: 0,
        value: ''
    },
    clientAttendees: '',
    internalAttendees: [{
        id: 0,
        value: ''
    }],
    aptTitle: '',
    locationNotes: "",
    comments: ''
}

export const initialValuesLeadSource = {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    firstContactDate: "",
    lst_MethodOfInquiry: {
        id: 0,
        value: ""
    },
    lst_LeadSourceCategory: {
        id: 0,
        value: ""
    },
    lst_LeadSource: {
        id: 0,
        value: ""
    },
    sourceDescription: "",
    adCode: ""
}